module.exports = __webpack_public_path__ + "img/Zapzaraptor.5e963845.svg";